/* global Homie */
import axios from 'axios';
import Init from '../components/Init'
import Login from '../components/Login'
import Phone from '../components/Phone'
import Email from '../components/Email'
import Contract from '../components/Contract'
import Confirmation from '../components/Confirmation'

let checkAndRedirectIfIsLogged = (to, from, next) => {
  if (Homie.is_logged && !Homie.user.is_admin) {
    if(!Homie.user.mobile_phone) {
      return next({name: 'auth.confirmation'});      
    }
  }
  next();
};
  
export default [
  {
    path: '/auth',
    component: Init,
    name: 'auth',
    props: true,
    meta: {
      requiredAuth: false
    },
    beforeEnter: checkAndRedirectIfIsLogged
  },
  {
    path: '/auth/confirmation',
    component: Confirmation,
    name: 'auth.confirmation',    
    meta: {
      requiredAuth: true
    },
  },
  {
    path: '/auth/login', 
    component: Login,
    name: 'auth.login',    
    meta: {
      requiredAuth: false
    },
    beforeEnter: checkAndRedirectIfIsLogged
  },
  { 
    path: '/auth/term', 
    component: Contract,
    name: 'auth.term',
    props: true,
    meta: {
      requiredAuth: true
    },
    beforeEnter: (to, from, next) => {
      if(Homie.user.has_publishing_agreement) return next();
      axios.post('/users/publishing-agreement.json')
        .then(() => {
          Homie.user.has_publishing_agreement = true;
          next();
        });
    }
  },
  { 
    path: '/auth/phone', 
    component: Phone,
    name: 'validate.phone',
    props: {},
    meta: {
      requiredAuth: true
    },
    beforeEnter: (to, from, next) => {
      axios.get(`/verifications/phone?value=${encodeURIComponent(Homie.user.mobile_phone)}`)
      .then(response => {
        if (response.data.confirmed) {
          next({name: 'validate.email'});
        }else {
          next();
        }
      });
    }
  },
  { 
    path: '/auth/email', 
    component: Email,
    name: 'validate.email',
    props: {},
    meta: {
      requiredAuth: true
    },
    beforeEnter: (to, from, next) => {
      axios.get(`/verifications/email?value=${encodeURIComponent(Homie.user.email)}`)
      .then(response => {
        if (response.data.confirmed) {
          next({name: 'presentation'});
        }else {
          next();
        }
      });
    }
  }
]